import { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { aiGenerateCalendar } from "../../services/api";
import { periodLabel } from "./calendarUtils";

export const CalendarAIDialog = ({ calendar, onClose, onGenerated }) => {
  const [prompt, setPrompt] = useState("");
  const [busy, setBusy] = useState(false);
  const generate = async () => {
    if (!prompt.trim()) { toast.error("Décrivez votre demande"); return; }
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await aiGenerateCalendar(calendar.id, { prompt });
      toast.success(data.message); onGenerated(); onClose(); setPrompt("");
    } catch (err) { toast.error(err.response?.data?.detail || "Génération impossible. Réessayez."); }
    finally { setBusy(false); }
  };
  return <Dialog open={!!calendar} onOpenChange={open => !open && !busy && onClose()}>
    <DialogContent className="responsive-dialog max-w-md overflow-y-auto" data-testid="ai-dialog" onOpenAutoFocus={event => { if (window.innerWidth < 1024) event.preventDefault(); }}>
      <DialogHeader><DialogTitle className="flex gap-2 pr-5 text-left" data-testid="ai-dialog-title"><Sparkles size={18} />Assistant IA</DialogTitle><DialogDescription className="text-left capitalize" data-testid="ai-calendar-scope">{calendar?.customer_name} · {calendar && periodLabel(calendar.period)}</DialogDescription></DialogHeader>
      <div><Label htmlFor="ai-prompt">Votre demande</Label><Textarea id="ai-prompt" rows={5} value={prompt} onChange={event => setPrompt(event.target.value)} disabled={busy} data-testid="ai-prompt-input" /></div>
      <DialogFooter className="gap-2"><Button variant="outline" disabled={busy} onClick={onClose} data-testid="ai-cancel-btn">Annuler</Button><Button disabled={busy} onClick={generate} data-testid="ai-generate-btn">{busy ? <Loader2 size={14} className="mr-2 animate-spin" /> : <Sparkles size={14} className="mr-2" />}{busy ? "En cours…" : "Exécuter"}</Button></DialogFooter>
    </DialogContent>
  </Dialog>;
};